export default __webpack_public_path__ + "static/media/signin_banner_Cn.43784b7e.jpg";